module.exports = __webpack_public_path__ + "img/icon_comment_active.5bd7f8bf.svg";